<jhi-custom-box [title]="user ? 'spans.editAccountInfo.boxtitle' : 'spans.editAccountInfo.boxtitlenouser'  "
                *ngIf="!showPrivacyPolicy"
                [requiredFields]="canAccessForm"
                [translateParams]="{username: user?.login}"
                [boxSize]="'box-580'"
                [contentLoading]="loading"
                [successMsg]="successMsg"
                (successEmitter)="redirect()"
                [successButtonLabel]="isFirstLogin ? 'buttons.returntoapp' : 'buttons.ok'"
                [errorMsg]="errorMsg"
                (failureEmitter)="redirectOnFailure()"
>
    <!-- Warning message for non-EXTRA_UE users when passwordless mode is enabled -->
    <div class="text-center mt-3 mb-3" *ngIf="!canAccessForm && pwdlessWarningMessage">
        <p class="text-danger">
            {{ pwdlessWarningMessage }}
        </p>
    </div>

    <!-- Show form only if user can access it -->
    <div *ngIf="canAccessForm">
    <form [formGroup]="userForm">

        <div class="form-group">
            <div class="row">
                    <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.editAccountInfo.formlabels.username"> Username </label>
                </div>

                <div class="col-sm-7">
                    <span class="font-weight-bold">{{ user?.login }}</span>
                </div>
            </div>


            <div class="row m-t-5">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.editAccountInfo.formlabels.firstName"> First name </label>
                </div>
                <div class="col-sm-7">
                    <span class="font-weight-bold">{{ user?.firstName }}</span>
                </div>
            </div>


            <div class="row m-t-5">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.editAccountInfo.formlabels.lastName"> Last name </label>
                </div>
                <div class="col-sm-7">
                    <span class="font-weight-bold">{{ user?.lastName }}</span>
                </div>
            </div>


            <div class="row m-t-5">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.editAccountInfo.formlabels.fiscalCode"> Fiscal code </label>
                </div>
                <div class="col-sm-7">
                    <span class="font-weight-bold">{{ user?.fiscalCode }}</span>
                </div>
            </div>



            <div class="row m-t-5">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="email-input" jhiTranslate="spans.editAccountInfo.formlabels.companyEmail"> Company e-mail </label>
                </div>
                <div class="col-sm-7 d-flex">
                    <input [readOnly]="submitted" [placeholder]="'spans.editAccountInfo.formplaceholders.companyEmail' | translate" id="email-input" type="email"
                           [formControlName]="'email'" class="form-control" [ngClass]="f.email.errors ? 'is-invalid': ''"
                           [email]="true" />
                    <div class="mt-2 ml-1" ngbTooltip="{{((verifiedEmail ? 'spans.common.verifiedMail' : 'spans.common.notVerifiedMail') | translate)}}" placement="right">
                        <fa-icon [icon]="faCheckCircle" [styles]="{'color': verifiedEmail ? 'green' : 'red'}" size="lg"></fa-icon>
                    </div>
                    <!--<svg [ngClass]="verifiedEmail ? 'green-check-icon' : 'red-check-icon'">
                        <use xlink:href="content/svg/sprite.svg#it-check-circle"></use>
                        <title>{{(verifiedEmail ? 'spans.common.verifiedMail' : 'spans.common.notVerifiedMail') | translate}}</title>
                    </svg>-->
                </div>
                <div class="col-sm-5"></div>
                <div class="col-sm-7">
                    <div *ngIf="fEmail.invalid" class="error-box">
                        <span *ngIf="fEmail.errors?.required" jhiTranslate="spans.editAccountInfo.formerrors.requiredCompanyEmail"> Email required </span>
                        <span *ngIf="fEmail.errors?.email" jhiTranslate="spans.editAccountInfo.formerrors.invalidEmail"> Invalid format </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="alt-email-input" jhiTranslate="spans.editAccountInfo.formlabels.alternativeEmail"> alternative e-mail </label>
                </div>
                <div class="col-sm-7 d-flex">
                    <input [readOnly]="submitted" [placeholder]="'spans.editAccountInfo.formlabels.alternativeEmail' | translate" id="alt-email-input" type="email"
                           [formControlName]="'alternativeEmail'" class="form-control"
                           [email]="true"/>
                    <!--<svg *ngIf="isNotEmpty(userForm.controls['alternativeEmail'])" [ngClass]="verifiedAltEmail ? 'green-check-icon' : 'red-check-icon'">
                        <use xlink:href="content/svg/sprite.svg#it-check-circle"></use>

                        <title>{{(verifiedAltEmail ? 'spans.common.verifiedMail' : 'spans.common.notVerifiedMail') | translate}}</title>
                    </svg>-->
                    <span class="mt-2" ngbTooltip="{{((verifiedAltEmail ? 'spans.common.verifiedMail' : 'spans.common.notVerifiedMail') | translate)}}" placement="right">
                    <fa-icon class="ml-1" *ngIf="isNotEmpty(userForm.controls['alternativeEmail'])"
                             [icon]="faCheckCircle" [styles]="{'color': verifiedAltEmail ? 'green' : 'red'}" size="lg"></fa-icon>
                    </span>
                    <!--<svg *ngIf="!isNotEmpty(userForm.controls['alternativeEmail'])" [ngClass]="'red-check-icon'">
                        <use xlink:href="content/svg/sprite.svg#it-check-circle"></use>
                        <title>{{('spans.common.alertAlternativeEmail') | translate}}</title>
                    </svg>-->
                    <span class="mt-2 info-email-tooltip" *ngIf="!isNotEmpty(userForm.controls['alternativeEmail']) && isMefMail">
                        <fa-icon class="ml-1" [icon]="faExclamationCircle" [styles]="{'color': 'red'}" size="lg"
                                 [ngbTooltip]="(('spans.common.alertAlternativeEmailMef') | translate)" [placement]="'right'"></fa-icon>
                    </span>
                    <span class="mt-2 info-email-tooltip" *ngIf="!isNotEmpty(userForm.controls['alternativeEmail']) && !isMefMail">
                        <fa-icon class="ml-1 " [icon]="faExclamationCircle" [styles]="{'color': 'red'}" size="lg"
                                 [ngbTooltip]="(('spans.common.alertAlternativeEmail') | translate)" [placement]="'right'"></fa-icon>
                    </span>
                </div>
                <div class="col-sm-5"></div>
                <div class="col-sm-7">
                    <div *ngIf="fAltEmail.invalid" class="error-box">
                        <span *ngIf="fAltEmail.errors?.email" jhiTranslate="spans.editAccountInfo.formerrors.invalidEmail"> Invalid format </span>
                    </div>
                    <div *ngIf="this.userForm.get('email').value === this.userForm.get('alternativeEmail').value" class="error-box">
                        <span *ngIf="this.userForm.get('email').value === this.userForm.get('alternativeEmail').value" jhiTranslate="spans.editAccountInfo.formerrors.emailEquals"> Invalid email </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="office-input" jhiTranslate="spans.editAccountInfo.formlabels.office"> Office </label>
                </div>
                <div class="col-sm-7">
                    <input [readOnly]="submitted" [placeholder]="'spans.editAccountInfo.formlabels.office' | translate" id="office-input" type="text" [formControlName]="'office'" class="form-control" [ngClass]="f.office.errors ? 'is-invalid': ''" />
                </div>
            </div>


            <div class="row m-t-5" *ngIf="phoneAcquisitionEnabled">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="phone-input" jhiTranslate="spans.editAccountInfo.formlabels.mobilePhone"> Mobile phone </label>
                </div>
                <div class="col-sm-7 d-flex">
                    <select class="prefix-select" id="prefix-select" [formControlName]="'prefixSelect'">
                        <option *ngFor="let option of prefixes" value="{{option}}">+{{option}}</option>
                    </select>
                    <input jhiDigitsOnly="true" [readOnly]="submitted" [placeholder]="'spans.editAccountInfo.formplaceholders.mobilePhone' | translate" id="phone-input" type="text" [formControlName]="'phone'" class="align-self-center form-control"/>
                    <svg *ngIf="isNotEmpty(userForm.controls['phone'])" [ngClass]="verifiedPhone ? 'green-check-icon' : 'red-check-icon'">
                        <use xlink:href="content/svg/sprite.svg#it-check-circle"></use>
                        <title>{{(verifiedPhone ? 'spans.common.verifiedPhone' : 'spans.common.notVerifiedPhone') | translate}}</title>
                    </svg>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="question-input" jhiTranslate="spans.editAccountInfo.formlabels.question"> Question </label>
                </div>
                <div class="col-sm-7">
                    <input [readOnly]="submitted" [placeholder]="'spans.editAccountInfo.formplaceholders.question' | translate" id="question-input" type="text" [formControlName]="'question'" class="form-control" [ngClass]="f.question.errors ? 'is-invalid': ''" />
                </div>
                <div class="col-sm-5"></div>
                <div class="col-sm-7 align-self-end">
                    <div *ngIf="fQuestion.invalid" class="error-box">
                        <span *ngIf="fQuestion.errors?.required" jhiTranslate="spans.editAccountInfo.formerrors.requiredQuestion"> Question required </span>
                    </div>
                </div>
            </div>



            <div class="row m-t-5">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="answer-input" jhiTranslate="spans.editAccountInfo.formlabels.answer"> Answer </label>
                </div>
                <div class="col-sm-7 input-group">
                    <input [readOnly]="isAnswerSetted" [placeholder]="'spans.editAccountInfo.formplaceholders.answer' | translate" id="answer-input"
                           [type]="isAnswerSetted ? 'password' : 'text'" [formControlName]="'answer'" class="form-control"
                           [ngClass]="f.answer.errors ? 'is-invalid': ''" />
                    <div class="input-group-append">
                        <button title="{{'spans.editAccountInfo.editAnswer' | translate}}" type="button" class="btn btn-outline-secondary w-43"
                                (click)="editAnswer($event)">
                            <fa-icon [icon]="faPenSquare" size="sm"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-sm-5"></div>
                <div class="col-sm-7 align-self-end">
                    <div *ngIf="fAnswer.invalid" class="error-box">
                        <span *ngIf="fAnswer.errors?.required" jhiTranslate="spans.editAccountInfo.formerrors.requiredAnswer"> Answer required </span>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="orgDag && canAccessForm && user?.pinEnabled">
                <div  class="row m-t-5"  *ngIf="orgDag && canAccessForm && user?.pinEnabled">
                    <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                        <label class="mb-0" for="pin-input" jhiTranslate="spans.editAccountInfo.formlabels.pin"> Pin </label>
                    </div>
                    <div class="col-sm-7 input-group">
                         <input maxlength="5" pattern="[0-9]{5}" [readOnly]="submitted"
                               [placeholder]="'spans.editAccountInfo.formplaceholders.pin' | translate" id="pin-input"
                               [type]="showPin ? 'text' : 'password'" [formControlName]="'pin'" class="form-control"
                               [ngClass]="f.pin.errors ? 'is-invalid': ''" />
                        <div class="input-group-append">
                            <button title="{{showPin ? 'spans.editAccountInfo.hidePin' : 'spans.editAccountInfo.showPin' | translate}}"
                                    type="button" class="btn btn-outline-secondary" (click)="changeShowPin($event)">
                                <fa-icon [icon]="showPin ? faEye : faEyeSlash"></fa-icon>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-5"></div>
                    <div class="col-sm-7 align-self-end">
                        <div *ngIf="fPin.invalid" class="error-box">
                            <span *ngIf="fPin.errors?.pattern" jhiTranslate="spans.editAccountInfo.formerrors.invalidPin"> Invalid pin </span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class="row m-t-5">
                <div class="col-sm-5 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.editAccountInfo.formlabels.privacyPolicy"> privacy </label>
                </div>
                <div class="col-sm-7 input-group">
                    <div class="row">
                        <div class="col-10">
                            <input type="checkbox" [formControlName]="'privacyCheckbox'" name="privacyCheckbox" id="privacyCheckbox"
                                [checked]="privacyPolicyUpToDate">
                            <label for="privacyCheckbox">&nbsp;{{'spans.acceptPrivacyPolicy' | translate}}</label>
                        </div>
                        <div class="col-2 readPolicy" (click)="showPrivacyPolicy = !showPrivacyPolicy">
                            {{'spans.read' | translate}}
                        </div>
                    </div>
                </div>
                <div class="col-sm-5"></div>
                <div class="col-sm-7">
                    <div *ngIf="!this.userForm.controls['privacyCheckbox'].value" class="error-box">
                        <span *ngIf="!this.userForm.controls['privacyCheckbox'].value" jhiTranslate="spans.editAccountInfo.formerrors.requiredPolicy"></span>
                    </div>
                </div>
            </div>
        </div>


        <div class="row text-center d-flex" *ngIf="!showPrivacyPolicy">
            <div class="col-12">
                <button [disabled]="submitted" type="button" class="btn secondary-btn float-left" (click)="backToApp()"
                        jhiTranslate="buttons.back">Return to application</button>
                <button [disabled]="submitted" (click)="onReset()" class="btn secondary-btn"
                        jhiTranslate="buttons.discard">Discard</button>

                <button [ladda]="submitted" *ngIf="enableConfirm" class="btn confirm-btn ladda-button max-w-150"
                        data-style="expand-right" (click)="onSubmit(false)" [disabled]="!(userForm.valid && userForm.dirty)" >
                    <span class="ladda-label" jhiTranslate="buttons.submit"></span>
                </button>

                <button [ladda]="submitted" *ngIf="!enableConfirm" class="btn confirm-btn ladda-button max-w-150"
                        data-style="expand-right" (click)="onSubmit(true)" [disabled]="!(userForm.valid && userForm.dirty)" >
                    <span class="ladda-label" jhiTranslate="buttons.ahead"></span>
                </button>
                &nbsp;
            </div>

        </div>
    </form>
    </div>

    <!-- Back button for users who cannot access the form -->
    <div class="row text-center d-flex" *ngIf="!canAccessForm">
        <div class="col-12">
            <button type="button" class="btn secondary-btn" (click)="backToApp()"
                    jhiTranslate="buttons.back">Return to application</button>
        </div>
    </div>

</jhi-custom-box>
<jhi-custom-box [boxSize]="'box-580'" *ngIf="showPrivacyPolicy" [title]="'spans.privacypolicy.boxtitle'">
    <div [innerHTML]="privacyPolicyHtml"></div>

    <button class="btn confirm-btn ladda-button max-w-120" data-style="expand-right"
            (click)="showPrivacyPolicy = !showPrivacyPolicy">
        <span class="ladda-label" jhiTranslate="buttons.back" ></span>
    </button>
</jhi-custom-box>
